import { WalletCard } from '@givebacks/api/backer';

import { ConsumerWalletEvent } from './ConsumerWalletEvent';
import { ConsumerWalletMembership } from './ConsumerWalletMembership';

const ConsumerWalletListCard = ({ walletCard }: { walletCard: WalletCard }) => {
  return (
    <>
      <ConsumerWalletEvent walletCard={walletCard} />
      <ConsumerWalletMembership walletCard={walletCard} />
    </>
  );
};

export { ConsumerWalletListCard };
